// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetBusinessUnitQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetBusinessUnitQuery = { __typename?: 'Query' } & {
  businessUnit: Types.Maybe<
    { __typename?: 'BusinessUnit' } & Pick<Types.BusinessUnit, 'id' | 'name'> & {
        valueDeliveredDepartment: Types.Maybe<
          { __typename?: 'EpmMasterVdd' } & Pick<Types.EpmMasterVdd, 'id' | 'name'>
        >;
        defaultEpmMasterRoleType: Types.Maybe<
          { __typename?: 'EpmMasterRoleType' } & Pick<Types.EpmMasterRoleType, 'id' | 'name'>
        >;
        definitions: Array<{ __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'content'>>;
      }
  >;
};

export const GetBusinessUnitDocument = /*#__PURE__*/ gql`
    query getBusinessUnit($id: ID!) {
  businessUnit(id: $id) {
    id
    name
    valueDeliveredDepartment {
      id
      name
    }
    defaultEpmMasterRoleType {
      id
      name
    }
    definitions {
      languageCode
      content
    }
  }
}
    `;

/**
 * __useGetBusinessUnitQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBusinessUnitQuery(
  baseOptions: Apollo.QueryHookOptions<GetBusinessUnitQuery, GetBusinessUnitQueryVariables> &
    ({ variables: GetBusinessUnitQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>(GetBusinessUnitDocument, options);
}
export function useGetBusinessUnitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>(GetBusinessUnitDocument, options);
}
// @ts-expect-error
export function useGetBusinessUnitSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>;
export function useGetBusinessUnitSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetBusinessUnitQuery | undefined, GetBusinessUnitQueryVariables>;
export function useGetBusinessUnitSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>(GetBusinessUnitDocument, options);
}
export type GetBusinessUnitQueryHookResult = ReturnType<typeof useGetBusinessUnitQuery>;
export type GetBusinessUnitLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitLazyQuery>;
export type GetBusinessUnitSuspenseQueryHookResult = ReturnType<typeof useGetBusinessUnitSuspenseQuery>;
